import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EnfermeiroService } from '../../enfermeiro.service';
import { AlertsService } from 'app/shared/alerts.service';
import { Router } from '@angular/router';
import { Paciente } from 'app/core/interfaces/pacient-info.interface';
import { OverlayService } from 'app/shared/overlay.service';
import { APIGestaCardService } from 'app/core/api/gestacard.service';
import { Organizacao } from 'app/core/interfaces/organizacao.interface';
import { Enfermeiro } from 'app/core/interfaces/enfermeiro.interface';
import { logger } from '../../../../core/utils/console';

@Component({
  selector: 'app-enfermeiro-cadastrar-paciente',
  templateUrl: './enfermeiro-cadastrar-paciente.component.html',
  styleUrls: ['./enfermeiro-cadastrar-paciente.component.scss']
})
export class EnfermeiroCadastrarPacienteComponent implements OnInit, AfterViewInit {

  form: FormGroup; 
  enfermeiro: Enfermeiro; 
  organizacao: Organizacao

  bloqueado_por_limite_de_cartoes = false;

  loading = false; 

  @ViewChild('cadastro_paciente') componente_cadastro_paciente; 
  @ViewChild('imageUploader') file_uploader_component;

  constructor(
    private enfermeiroService: EnfermeiroService, 
    private snackService: AlertsService, 
    private router: Router, 
    private overlayService: OverlayService,
    private _apigestacard: APIGestaCardService
    ) { }

  ngOnInit() {

  }

  ngAfterViewInit() {

    this.form = this.componente_cadastro_paciente.form; 

    this.BuscarDados(); 

  }

  BuscarDados() {
    this.enfermeiroService.GetUserData().subscribe((res) => {
      this.enfermeiro = res; 

      this.enfermeiroService.GetOrgData().subscribe((org) => {
        this.organizacao = org;
        this.AtualizarFormulario();

        if (this.organizacao.instituicao_publica === 'S') return;

        this.enfermeiroService.TotalCartoesUsadosPeloEnfermeiro(this.enfermeiro.id).then((result) => {
          
          if (result >= this.enfermeiro.maximo_cartoes) this.bloqueado_por_limite_de_cartoes = true;
          
        }).catch((err) => {

          logger.log("MedicoCadastrarPacienteComponent -> BuscarPerfilMedico -> err", err)
          
        });
      
      });
    });
  }

  AtualizarFormulario() {
    this.componente_cadastro_paciente.enabledSearchEmail = true;
  
    if (this.enfermeiro) {
      this.form.patchValue({
        enfermeiro: `${this.enfermeiro.primeiro_nome} ${this.enfermeiro.sobrenome}`, 
        telefone_enfermeiro: this.enfermeiro.telefone, 
      }); 
    }

    this.form.removeControl('medico_app');
    this.form.removeControl('enfermeiro_app');

    if (this.organizacao.instituicao_publica === 'S') return
    
    this.form.removeControl('cns');
  }

  SalvarPaciente() {

    if (this.form.valid) {

      this.loading = true;
      this.overlayService.show(); 

      var aux = this.form.value; 
      aux.enfermeiro_app = this.enfermeiro.id; 
      const paciente_criado = Paciente.create(aux); 

      this.enfermeiroService.CadastrarPaciente(paciente_criado).then(async (res) => {

        try {

          var imagem_aux = this.file_uploader_component.imagePath;

          // Salvando a imagem 
          if (imagem_aux) {
            var imagem = imagem_aux[0];
            var url_imagem = await this._apigestacard.UploadImage(imagem);

            await this._apigestacard.AtualizarUrlPerfil(res.id, url_imagem);
          }

          this.snackService.SnackMessage('Cadastro feito com sucesso!'); 
          this.router.navigate(['/enfermeiro']);
          
        } catch (error) {

          logger.log("EnfermeiroCadastrarPacienteComponent -> SalvarPaciente -> error", error);

        }

      }).catch((err) => {
        var message = '';
        if (typeof err === 'string') message = err;
        if (err.hasOwnProperty('message')) message = err.message;

        if (message == '') message = 'Erro ao cadastrar paciente.';
        
        this.snackService.SnackMessage(message); 

      }).finally(() => {

        this.loading = false;
        this.overlayService.hide(); 

      })

    } else {

      this.snackService.SnackMessage('Formulário invalido'); 

    }

  }

}
